import React from 'react';
import { Form, Card, Alert, Row, Col } from 'react-bootstrap';
import FileUploadDemo from './shared/FileUploadDemo';

const RiberaStep3 = ({ formData, onChange }) => {
    const handleFileChange = (name, file) => {
        onChange({ ...formData, [name]: file });
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        onChange({ ...formData, [name]: value });
    };

    return (
        <Card className="shadow-sm">
            <Card.Header className="bg-primary text-white">
                <h5 className="mb-0">Paso 3: Documentación Técnica</h5>
            </Card.Header>
            <Card.Body>
                <Alert variant="info" className="mb-4">
                    <strong>Documentación Técnica del Proyecto:</strong> Incluya el plano georreferenciado
                    y la memoria descriptiva del trabajo realizado.
                </Alert>

                <h6 className="text-primary mb-3">Plano Georreferenciado de Línea de Ribera</h6>

                <Row>
                    <Col md={6}>
                        <FileUploadDemo
                            label="Plano en Formato Digital (DXF)"
                            name="planoDXF"
                            accept=".dxf"
                            file={formData.planoDXF}
                            onChange={handleFileChange}
                            required={true}
                        />
                    </Col>
                    <Col md={6}>
                        <FileUploadDemo
                            label="Plano Firmado (PDF)"
                            name="planoPDF"
                            accept=".pdf"
                            file={formData.planoPDF}
                            onChange={handleFileChange}
                            required={true}
                        />
                    </Col>
                </Row>

                <Alert variant="secondary" className="mb-3">
                    <small>
                        El plano debe estar firmado por el profesional actuante y el Colegio Profesional correspondiente.
                    </small>
                </Alert>

                <FileUploadDemo
                    label="Memoria Descriptiva (PDF)"
                    name="memoriaDescriptiva"
                    accept=".pdf"
                    file={formData.memoriaDescriptiva}
                    onChange={handleFileChange}
                    required={true}
                />

                <Alert variant="warning" className="mb-3">
                    <small>
                        <strong>Requisitos de la Memoria Descriptiva:</strong>
                        <ul className="mb-0 mt-2">
                            <li>Procedimiento de los trabajos de campo</li>
                            <li>Criterio utilizado para la delimitación de la línea de ribera</li>
                            <li>Imágenes y características del cauce</li>
                            <li>Altura de la barranca y distancia a la mensura</li>
                        </ul>
                    </small>
                </Alert>

                <Form.Group className="mb-3">
                    <Form.Label>
                        Email para Observaciones Técnicas
                    </Form.Label>
                    <Form.Control
                        type="email"
                        name="emailObservaciones"
                        value={formData.emailObservaciones || ''}
                        onChange={handleChange}
                        placeholder="observaciones@ejemplo.com"
                    />
                    <Form.Text className="text-muted">
                        A este correo se enviarán eventuales observaciones o modificaciones solicitadas
                    </Form.Text>
                </Form.Group>
            </Card.Body>
        </Card>
    );
};

export default RiberaStep3;
